import { render, staticRenderFns } from "./ArchimedesPrincipleViz.vue?vue&type=template&id=549d2636&scoped=true"
import script from "./ArchimedesPrincipleViz.vue?vue&type=script&lang=js"
export * from "./ArchimedesPrincipleViz.vue?vue&type=script&lang=js"
import style0 from "./ArchimedesPrincipleViz.vue?vue&type=style&index=0&id=549d2636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d2636",
  null
  
)

export default component.exports